import UserAvatar from './UserAvatar';

export { sizes } from './UserAvatar';
export default UserAvatar;
